import React, { Component } from 'react';
import { injectSheet } from 'redux-form-jsonschema-reactstrap'
import { Field } from 'redux-form'


export function selectRange(_options) {
  const { styles, ...options } = _options;
  class CreatedInputField extends Component {
    render() {
      const min = this.props.schemaVis.schema.minimum || 0;
      const max = this.props.schemaVis.schema.maximum || 10;
      const step = this.props.schemaVis.schema.step || 1;
      const value = this.props.schemaVis.schema.default || undefined
      var items = []
      for (var i = min; i <= max; i = i + step) {
        items.push(
          <option key={i} value={i}>{i}</option>
        )
      }

      return (
        <Field component="select" value={value} {...this.props} {...options} >
          {items}
        </Field>
      )
    }
  }
  return injectSheet(styles)(CreatedInputField);
}


export default selectRange({})
